<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-timeline>
      <a-timeline-item v-for="(bank,index) in bankList" :key="index" color="green">
        <p>{{ bank.createTime }}</p>
        <p>{{ '银行卡号 : ' + bank.bankNo }}</p>
        <p>{{ '银行名称 : ' + bank.bankName }}</p>
        <p>{{ '所属支行 : ' + bank.bankSubName }}</p>
        <p>{{ '真实姓名 : ' + bank.realName }}</p>
        <p>{{ '手机号 : ' + bank.mobile }}</p>
        <p>{{ '状态 : ' + (bank.status === 1 ? '待审核' : bank.status === 2 ? '审核成功' : bank.status === 3 ? '审核失败' : bank.status === 4 ? '解绑待审核' : '解绑审核成功') }}</p>
      </a-timeline-item>
    </a-timeline>
  </a-drawer>
</template>

<script>
import { queryBankListById } from '@/api/biz/user'
export default {
  name: 'BankForm',
  data () {
    return {
      formTitle: null,
      open: false,
      bankList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '银行卡更换记录'
      const param = { id: id }
      queryBankListById(param).then(response => {
        this.bankList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
